// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3oqBE","item":"PaymentsMobile_item__3PwmY","label":"PaymentsMobile_label__3jbrw","amount":"PaymentsMobile_amount__38B6c"};